import { connect } from 'react-redux';
import Main from './main';
import { loadOrders, initPrinter } from '../reducers/order.reducers';
import { loadUiOptions, setWindowSize } from '../reducers/app.reducers';
import { loadProductionPlacesAction } from '../reducers/menu.reducers';

const mapStateToProps = state => ({
  title: state.navigator.title,
  loggedIn: state.authentication.loggedIn,
  selectedFilterMode: state.orders.selectedMode,
  windowsize: state.app.windowsize,
  localSettings: state.app.localSettings,
});

const mapDispatchToProps = dispatch => ({
  loadOrders: () => dispatch(loadOrders()),
  loadUiOptions: () => dispatch(loadUiOptions()),
  // subscribeForOrderUpdates: () => dispatch(subscribeForOrderUpdates()),
  initPrinter: (ipAddress, port) => dispatch(initPrinter(ipAddress, port)),
  setWindowSize: size => dispatch(setWindowSize(size)),
  loadProductionPlaces: () => dispatch(loadProductionPlacesAction.INIT()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Main);
